/**
 * Embroidery "Personalize It!" modal: logo upload + position selection.
 * Populates hidden cart line-item properties on the product form (see
 * snippets/embroidery-personalize-fields.liquid), then — after the main
 * product line is added to cart — adds a companion "Embroidery Add-On"
 * line to realize the flat per-position surcharge.
 */
(function () {
  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  var strings = (window.theme && window.theme.strings) || {};

  function money(cents) {
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    return "£" + (cents / 100).toFixed(2);
  }

  function initModal(modalEl) {
    var productId = modalEl.getAttribute("data-product-id");
    var uploadUrl = modalEl.getAttribute("data-upload-url");
    var positionPriceCents = parseInt(modalEl.getAttribute("data-position-price"), 10) || 0;

    var fileInput = $("[data-personalize-file-input]", modalEl);
    var preview = $("[data-personalize-preview]", modalEl);
    var previewImage = $("[data-personalize-preview-image]", modalEl);
    var previewStatus = $("[data-personalize-preview-status]", modalEl);
    var errorEl = $("[data-personalize-error]", modalEl);
    var dropzoneText = $("[data-personalize-dropzone-text]", modalEl);
    var defaultDropzoneText = dropzoneText ? dropzoneText.textContent : "";
    var positionInputs = $all("[data-personalize-position]", modalEl);
    var totalEl = $("[data-personalize-total]", modalEl);
    var applyBtn = $("[data-personalize-apply]", modalEl);
    var cancelBtn = $("[data-personalize-cancel]", modalEl);

    var fieldsRoot = document.querySelector(
      '[data-embroidery-fields][data-product-id="' + productId + '"]',
    );
    var logoInput = fieldsRoot && fieldsRoot.querySelector("[data-embroidery-logo-input]");
    var positionInputHidden =
      fieldsRoot && fieldsRoot.querySelector("[data-embroidery-position-input]");
    var moqInput = fieldsRoot && fieldsRoot.querySelector("[data-embroidery-moq-input]");
    var groupIdInput =
      fieldsRoot && fieldsRoot.querySelector("[data-embroidery-group-id-input]");

    var trigger = document.querySelector(".js-modal-open-personalize-" + productId);

    var uploadedUrl = null;
    var uploading = false;

    function selectedPositions() {
      return positionInputs.filter(function (input) {
        return input.checked;
      }).map(function (input) {
        return input.value;
      });
    }

    function updateApplyState() {
      var hasPositions = selectedPositions().length > 0;
      var ready = uploadedUrl && hasPositions && !uploading;
      if (applyBtn) applyBtn.classList.toggle("is-disabled", !ready);
    }

    function updateTotal() {
      var count = selectedPositions().length;
      if (totalEl) totalEl.textContent = money(count * positionPriceCents);
      updateApplyState();
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || "";
      errorEl.hidden = !message;
    }

    positionInputs.forEach(function (input) {
      input.addEventListener("change", updateTotal);
    });

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        showError("");
        uploadedUrl = null;
        if (previewStatus) previewStatus.classList.remove("personalize-modal__preview-status--success");
        updateApplyState();
        if (!file) return;

        var allowedTypes = ["image/jpeg", "image/png", "image/webp"];
        if (allowedTypes.indexOf(file.type) === -1) {
          showError(strings.personalizeFileTypeError || "Please choose a JPG, PNG, or WEBP file.");
          fileInput.value = "";
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          showError(
            strings.personalizeFileSizeError ||
              "That file is too large — please choose one under 10MB.",
          );
          fileInput.value = "";
          return;
        }

        if (dropzoneText) dropzoneText.textContent = file.name;
        if (preview) preview.hidden = false;
        if (previewImage) previewImage.src = URL.createObjectURL(file);
        if (previewStatus) previewStatus.textContent = strings.personalizeUploading || "Uploading…";
        uploading = true;
        updateApplyState();

        var body = new FormData();
        body.append("file", file);

        fetch(uploadUrl, { method: "POST", body: body })
          .then(function (response) {
            if (!response.ok) throw new Error("upload failed");
            return response.json();
          })
          .then(function (data) {
            if (!data.url) throw new Error("no url returned");
            uploadedUrl = data.url;
            if (previewStatus) {
              previewStatus.textContent = strings.personalizeLogoUploaded || "✓ Logo uploaded";
              previewStatus.classList.add("personalize-modal__preview-status--success");
            }
          })
          .catch(function () {
            showError(
              strings.personalizeUploadError ||
                "Something went wrong uploading your logo — please try again.",
            );
            if (preview) preview.hidden = true;
            if (dropzoneText) dropzoneText.textContent = defaultDropzoneText;
          })
          .finally(function () {
            uploading = false;
            updateApplyState();
          });
      });
    }

    if (applyBtn) {
      applyBtn.addEventListener("click", function () {
        var positions = selectedPositions();

        if (uploading) {
          showError(strings.personalizeUploading || "Uploading…");
          return;
        }
        if (!uploadedUrl) {
          showError(
            strings.personalizeLogoRequiredError || "Please upload your logo first.",
          );
          return;
        }
        if (positions.length === 0) {
          showError(
            strings.personalizePositionRequiredError || "Please choose at least one position.",
          );
          return;
        }

        var groupId = "embroidery-" + productId + "-" + Date.now();

        if (logoInput) logoInput.value = uploadedUrl;
        if (positionInputHidden) positionInputHidden.value = positions.join(", ");
        if (moqInput) moqInput.disabled = false;
        if (groupIdInput) {
          groupIdInput.value = groupId;
          groupIdInput.disabled = false;
        }

        if (trigger) {
          trigger.classList.add("is-personalized");
          trigger.textContent = strings.personalizeConfiguredButton || "Personalized ✓ — Edit";
        }

        var closeBtn = $(".js-modal-close", modalEl);
        if (closeBtn) closeBtn.click();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener("click", function () {
        uploadedUrl = null;
        if (fileInput) fileInput.value = "";
        positionInputs.forEach(function (input) {
          input.checked = false;
        });
        if (preview) preview.hidden = true;
        if (previewStatus) previewStatus.classList.remove("personalize-modal__preview-status--success");
        if (dropzoneText) dropzoneText.textContent = defaultDropzoneText;
        showError("");
        updateTotal();

        // Clear anything previously applied to the product form too, so a
        // customer can add a later batch of this product without embroidery.
        if (logoInput) logoInput.value = "";
        if (positionInputHidden) positionInputHidden.value = "";
        if (moqInput) moqInput.disabled = true;
        if (groupIdInput) {
          groupIdInput.value = "";
          groupIdInput.disabled = true;
        }
        if (trigger) {
          trigger.classList.remove("is-personalized");
          trigger.textContent = strings.personalizeButton || "Personalize It!";
        }

        var closeBtn = $(".js-modal-close", modalEl);
        if (closeBtn) closeBtn.click();
      });
    }
  }

  // After ANY product line is added to cart, check whether it carried
  // embroidery properties and, if so, add the companion Embroidery Add-On
  // line(s) to realize the flat per-position surcharge.
  document.addEventListener("ajaxProduct:added", function (evt) {
    var addedProduct = evt.detail && evt.detail.product;
    var properties = addedProduct && addedProduct.properties;
    if (!properties) return;

    var positionValue = properties["Embroidery Position"];
    if (!positionValue) return;

    var addonVariantId = window.theme && window.theme.embroideryAddonVariantId;
    if (!addonVariantId) return;

    var quantity = positionValue.split(",").filter(Boolean).length;
    if (quantity < 1) return;

    var body = new FormData();
    body.append("id", addonVariantId);
    body.append("quantity", String(quantity));
    body.append("properties[_embroidery_group_id]", properties["_embroidery_group_id"] || "");
    body.append("properties[_embroidery_moq]", "true");

    var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || "/cart/add.js";

    fetch(cartAddUrl, { method: "POST", body: body, credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (addonProduct) {
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", { detail: { product: addonProduct }, bubbles: true }),
        );
      });
  });

  document.addEventListener("DOMContentLoaded", function () {
    $all(".modal--personalize").forEach(function (modalEl) {
      var productId = modalEl.getAttribute("data-product-id");
      if (window.theme && typeof window.theme.Modals === "function") {
        new window.theme.Modals("PersonalizeModal-" + productId, "personalize-" + productId);
      }
      initModal(modalEl);
    });
  });
})();
